export const InstallationState = {
	url: '/installation/:consultationId',
	title: 'Installation Items',
	template: '<installation-page></installation-page>',
	params: {
		consultationId: {
			type: 'path',
			squash: true,
		},
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "installationPageMod" */
			'@Containers/builder-installation-page/installation-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
	resolve: [
		{
			token: 'stateStatus',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (ResolveSvc, trans) =>
				ResolveSvc.validateConsultationPrivate({status: 'draft', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
	],
};

export const InstallationInspectorState = {
	url: '/inspector/:consultationId/:proposalId',
	title: 'Proposal Inspector',
	template: '<installation-inspector-page></installation-inspector-page>',
	params: {consultationId: null, proposalId: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "installationInspectorPageMod" */
			'@Containers/builder-installation-page/installation-inspector-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
